const preventHandleContactSuggestion = () => () => {
  // do nothing
};

export default preventHandleContactSuggestion;
